import axios from "axios";
import { ElNotification } from "element-plus";
import { attachTokenRefresh } from "@/utils/authInterceptors";
// import { logoutUser } from "@/utils"
// import { getServiceConfigHeaders } from "./requestConfig";


export const orderKitService = axios.create({
  baseURL: process.env.VUE_APP_ENV === "production"
        ? "https://api.vibrant-wellness.com/v2/portal/order" // production
        : "https://api.vibrant-wellness.com/v2/portal/order-staging" //staging
});



orderKitService.interceptors.request.use(
  async function (config) {
    // config.headers = await getServiceConfigHeaders();
    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

orderKitService.interceptors.response.use(
  (response) => {
    // const res = response.data;
    // removed res
    if (response.status !== 200 && response.status !== 204) {

      ElNotification({
        title: "Failed",
        message: response.message,
        type: "error",
      });
      return Promise.reject("error");
    } else {
      return response;
    }
  },
  (error) => {
    console.log("err ", error);
    if (error.response.status === 401) {
      // logoutUser();
      return Promise.reject(error);
    }
    else {
      let message = error.message;
      if (error.response) {
        let { data } = error.response;
        if (data) {
          message = data.error ? data.error : message;
        }
      }
      ElNotification({
        title: "Failed",
        message,
        type: "error"
      });
    }

    return Promise.reject(error);
  }
);

attachTokenRefresh(orderKitService);

export default orderKitService;